import { render, staticRenderFns } from "./Digital99AssistanceSetting.vue?vue&type=template&id=72650367&scoped=true&"
import script from "./Digital99AssistanceSetting.vue?vue&type=script&lang=js&"
export * from "./Digital99AssistanceSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72650367",
  null
  
)

export default component.exports